import { Trans } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

import { Spinner } from "../spinner";

type RefreshLabelProps = { active: boolean; className?: string };

// «Обновляем» со спиннером в шапке блока, пока данные перечитываются.
export const RefreshLabel = ({ active, className }: RefreshLabelProps) =>
  active ? (
    <span
      role="status"
      className={cn("inline-flex items-center gap-1.5 text-xs text-subtle", className)}
    >
      <Spinner className="size-3" />
      <Trans>Updating</Trans>
    </span>
  ) : null;
